import React from "react";

export default {
  title: "GLOSSARY"
}
